import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { RTLProps } from '@/shared/prop-types/ReducerProps';

export const ApplicantColumns = [
  {
    id: 'applicantSelect',
    label: 'Select',
    disablePadding: true,
  },
  {
    id: null,
    label: '',
    disablePadding: false,
  },
  {
    id: 'name',
    label: 'Name',
    disablePadding: true,
  },
  {
    id: 'email',
    label: 'Email',
    disablePadding: true,
  },
  {
    id: 'isBhumiputera',
    label: 'Is Bhumiputera',
    disablePadding: true,
  },
  {
    id: 'university',
    label: 'University',
    disablePadding: true,
  },
  {
    id: 'enrollmentDate',
    label: 'Enrollment Date',
    disablePadding: true,
  },
  {
    id: 'program',
    label: 'Program',
    disablePadding: true,
  },
  {
    id: 'stage',
    label: 'Applicant Stage',
    disablePadding: true,
  },
  {
    id: 'status',
    label: 'Applicant Status',
    disablePadding: true,
  },
];

const createSortHandler = (property, onRequestSort) => (event) => {
  onRequestSort(event, property);
};

const ApplicantTableColumns = ({ order, orderBy, rtl, onRequestSort }) => (
  <Fragment>
    <TableRow>
      {ApplicantColumns.map((row) => (
        <TableCell
          className="material-table__cell material-table__cell--sort material-table__cell-center"
          key={row.id}
          align={row.id == 'title' ? 'left' : 'center'}
          padding={row.disablePadding ? 'none' : 'default'}
          sortDirection={orderBy === row.id ? order : false}
        >
          <TableSortLabel
            active={orderBy === row.id}
            direction={order}
            onClick={createSortHandler(row.id, onRequestSort)}
            className="material-table__sort-label"
            dir="ltr"
          >
            <b>{row.label}</b>
          </TableSortLabel>
        </TableCell>
      ))}
    </TableRow>
  </Fragment>
);

ApplicantTableColumns.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rtl: RTLProps.isRequired,
};

export default connect((state) => ({
  rtl: state.rtl,
}))(ApplicantTableColumns);
